import * as sections from 'constants/sections';
import { i18n } from 'config/locales';

export const FINANCIAL = {
  key: sections.FINANCIAL,
  name: 'financial',
  path: 'financial',
  store: 'Financial',
  label: i18n.t('financial.section.name'),
};

export const FINANCIAL_INTRO = {
  key: sections.FINANCIAL_INTRO,
  name: 'intro',
  path: 'intro',
  label: i18n.t('financial.subsection.intro'),
};

export const FINANCIAL_ALIMONY = {
  key: sections.FINANCIAL_ALIMONY,
  name: 'alimony',
  path: 'alimony',
  storeKey: 'Alimony',
  label: i18n.t('financial.pvq.subsection.alimony'),
};

export const FINANCIAL_CHILD_SUPPORT = {
  key: sections.FINANCIAL_CHILD_SUPPORT,
  name: 'childsupport',
  path: 'childsupport',
  storeKey: 'ChildSupport',
  label: i18n.t('financial.pvq.subsection.childsupport')
};

export const FINANCIAL_CIVIL_JUDGEMENT = {
  key: sections.FINANCIAL_CIVIL_JUDGEMENT,
  name: 'civiljudgement',
  path: 'civiljudgement',
  storeKey: 'CivilJudgement',
  label: i18n.t('financial.pvq.subsection.civiljudgement')
};

export const FINANCIAL_LIEN = {
  key: sections.FINANCIAL_LIEN,
  name: 'lien',
  path: 'lien',
  storeKey: 'Lien',
  label: i18n.t('financial.pvq.subsection.lien')
};

export const FINANCIAL_FORECLOSURE = {
  key: sections.FINANCIAL_FORECLOSURE,
  name: 'foreclosure',
  path: 'foreclosure',
  storeKey: 'Foreclosure',
  label: i18n.t('financial.pvq.subsection.foreclosure')
};

export const FINANCIAL_REPOSSESSION = {
  key: sections.FINANCIAL_REPOSSESSION,
  name: 'repossession',
  path: 'repossession',
  storeKey: 'Repossession',
  label: i18n.t('financial.pvq.subsection.repossession')
};

export const FINANCIAL_EVICTION = {
  key: sections.FINANCIAL_EVICTION,
  name: 'eviction',
  path: 'eviction',
  storeKey: 'Eviction',
  label: i18n.t('financial.pvq.subsection.eviction')
};

export const FINANCIAL_ASSET_SEIZED = {
  key: sections.FINANCIAL_ASSET_SEIZED,
  name: 'assetseized',
  path: 'assetseized',
  storeKey: 'AssetSeized',
  label: i18n.t('financial.pvq.subsection.assetseized')
};

export const FINANCIAL_BANKRUPTCY = {
  key: sections.FINANCIAL_BANKRUPTCY,
  name: 'bankruptcy',
  path: 'bankruptcy',
  storeKey: 'Bankruptcy',
  label: i18n.t('financial.subsection.bankruptcy'),
};

export const FINANCIAL_GAMBLING = {
  key: sections.FINANCIAL_GAMBLING,
  name: 'gambling',
  path: 'gambling',
  storeKey: 'Gambling',
  label: i18n.t('financial.subsection.gambling'),
};

export const FINANCIAL_NONPAYMENT_NONFEDERAL = {
  key: sections.FINANCIAL_NONPAYMENT_NONFEDERAL,
  name: 'nonpaymentnonfederal',
  path: 'nonpaymentnonfederal',
  storeKey: 'NonpaymentNonfederal',
  label: i18n.t('financial.pvq.subsection.nonpaymentnonfederal'),
};

export const FINANCIAL_TAXES = {
  key: sections.FINANCIAL_TAXES,
  name: 'taxes',
  path: 'taxes',
  storeKey: 'Taxes',
  label: i18n.t('financial.subsection.taxes'),
};

export const FINANCIAL_FEDERAL_DEBT = {
  key: sections.FINANCIAL_FEDERAL_DEBT,
  name: 'federaldebt',
  path: 'federaldebt',
  storeKey: 'FederalDebt',
  label: i18n.t('financial.pvq.subsection.federalDebt'),
};

export const FINANCIAL_CARD = {
  key: sections.FINANCIAL_CARD,
  name: 'card',
  path: 'card',
  storeKey: 'Card',
  label: i18n.t('financial.subsection.card'),
};

export const FINANCIAL_CREDIT = {
  key: sections.FINANCIAL_CREDIT,
  name: 'credit',
  path: 'credit',
  storeKey: 'Credit',
  label: i18n.t('financial.subsection.credit'),
};

export const FINANCIAL_DELINQUENT = {
  key: sections.FINANCIAL_DELINQUENT,
  name: 'delinquent',
  path: 'delinquent',
  storeKey: 'Delinquent',
  label: i18n.t('financial.subsection.delinquent'),
};

export const FINANCIAL_NONPAYMENT = {
  key: sections.FINANCIAL_NONPAYMENT,
  name: 'nonpayment',
  path: 'nonpayment',
  storeKey: 'Nonpayment',
  label: i18n.t('financial.subsection.nonpayment'),
};

export const FINANCIAL_REVIEW = {
  key: sections.FINANCIAL_REVIEW,
  name: 'review',
  path: 'review',
  label: i18n.t('financial.subsection.review'),
};

export default {
  FINANCIAL,
  FINANCIAL_INTRO,
  FINANCIAL_BANKRUPTCY,
  FINANCIAL_GAMBLING,
  FINANCIAL_FEDERAL_DEBT,
  FINANCIAL_ALIMONY,
  FINANCIAL_CHILD_SUPPORT,
  FINANCIAL_CIVIL_JUDGEMENT,
  FINANCIAL_LIEN,
  FINANCIAL_FORECLOSURE,
  FINANCIAL_REPOSSESSION,
  FINANCIAL_EVICTION,
  FINANCIAL_ASSET_SEIZED,
  FINANCIAL_NONPAYMENT_NONFEDERAL,
  FINANCIAL_TAXES,
  FINANCIAL_CARD,
  FINANCIAL_CREDIT,
  FINANCIAL_DELINQUENT,
  FINANCIAL_NONPAYMENT,
  FINANCIAL_REVIEW,
};
